"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base = void 0;
exports.base = {
    addColumnAfter: "הוסף עמודה אחרי",
    addColumnBefore: "הוסף עמודה לפני",
    addRowAfter: "הוסף שורה אחרי",
    addRowBefore: "הוסף שורה לפני",
    alignCenter: "מרכוז",
    alignLeft: "ישר לשמאל",
    alignRight: "ישר לימין",
    bulletList: "רשימה עם תבליטים",
    checkboxList: "רשימה עם תיבות סימון",
    codeBlock: "קוד",
    codeCopied: "הקוד הועתק",
    codeInline: "קוד בשורה",
    createLink: "צור קישור",
    createLinkError: "אירעה שגיאה בעת יצירת הקישור",
    createNewDoc: "צור מסמך חדש",
    deleteColumn: "מחק עמודה",
    deleteRow: "מחק שורה",
    deleteTable: "מחק טבלה",
    deleteImage: "מחק תמונה",
    downloadImage: "הורד תמונה",
    replaceImage: "החלף תמונה",
    alignImageLeft: "ישר תמונה לשמאל",
    alignImageRight: "ישר תמונה לימין",
    alignImageDefault: "ישר תמונה למרכוז",
    em: "נטוי",
    embedInvalidLink: "הקישור שצורף אינו תקין",
    findOrCreateDoc: "מצא או צור מסמך",
    h1: "כותרת גדולה",
    h2: "כותרת בינונית",
    h3: "כותרת קטנה",
    heading: "כותרת",
    hr: "קו הפרדה",
    image: "תמונה",
    imageUploadError: "אירעה שגיאה בעת העלאת התמונה",
    imageCaptionPlaceholder: "הוסף תיאור...",
    info: "מידע",
    infoNotice: "הודעה אינפורמטית",
    link: "קישור",
    linkCopied: "הקישור הועתק",
    mark: "סימון",
    newLineEmpty: "הקלד '/' כדי להוסיף...",
    newLineWithSlash: "המשך להקליד כדי לסנן…",
    noResults: "לא נמצאו תוצאות",
    openLink: "פתח קישור",
    orderedList: "רשימה ממוספרת",
    pageBreak: "קצה עמוד",
    pasteLink: "הדבק קישור...",
    pasteLinkWithTitle: (title) => `Paste a ${title} link…`,
    placeholder: "מציין מיקום",
    quote: "ציטוט",
    removeLink: "הסר קישור",
    searchOrPasteLink: "...הדבק קישור",
    strikethrough: "קו חוצה",
    strong: "מודגש",
    subheading: "כותרת משנה",
    table: "טבלה",
    tip: "עצה",
    tipNotice: "הודעת עצה",
    warning: "אזהרה",
    warningNotice: "הודעת אזהרה",
};
exports.default = exports.base;
